import log from 'salvo-lite/log'

class Popup {
    constructor (theme, elem) {
        this._theme = theme
        this._popup = elem
        this._triggers = document.querySelectorAll(`[data-popup-trigger='${this._popup.dataset.popup}']`)
        this._closeTriggers = this._popup.querySelectorAll('[data-popup-close]')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)

        if (location.hash === `#${this._popup.dataset.popup}`) {
            this._popup.classList.add('shown')
            document.body.classList.add('no-scroll')
        }

        for (let trigger of this._triggers) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault()
                this._popup.classList.add('shown')
                document.body.classList.add('no-scroll')
            })
        }

        this._popup.addEventListener('click', (e) => {
            if (e.target === this._popup) {
                this._popup.classList.remove('shown')
                document.body.classList.remove('no-scroll')
            }
        })

        for (let trigger of this._closeTriggers) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault()
                this._popup.classList.remove('shown')
                document.body.classList.remove('no-scroll')
            })
        }

        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default Popup



// WEBPACK FOOTER //
// ./src/scripts/components/Popup.js